import { trimmedOrNull } from '@/components/Account/ServiceCatalog/utils';

// `fleet_size` is an int column; nine digits keeps it under the int4 max. Blank clears it.
export const isWholeFleetSize = (value) => {
    const fleetSize = `${value ?? ''}`.trim();

    return /^\d{0,9}$/.test(fleetSize);
};

/** UPDATE_CLIENT_BY_PK patch from the Carrier identity modal. Check `isWholeFleetSize` first. */
export const identityPatch = (draft) => {
    const fleetSize = `${draft.fleet_size ?? ''}`.trim();

    return {
        dot_number: trimmedOrNull(draft.dot_number),
        mc_num: trimmedOrNull(draft.mc_num),
        business_ein: trimmedOrNull(draft.business_ein),
        fleet_size: fleetSize ? Number(fleetSize) : null,
    };
};

/** UPDATE_CLIENT_BY_PK patch from the Billing information modal. */
export const billingPatch = (draft) => ({
    business_name: trimmedOrNull(draft.business_name),
    alias: trimmedOrNull(draft.alias),
    billing_address: trimmedOrNull(draft.billing_address),
    billing_address_unit: trimmedOrNull(draft.billing_address_unit),
    billing_city: trimmedOrNull(draft.billing_city),
    billing_state: trimmedOrNull(draft.billing_state),
    billing_zip: trimmedOrNull(draft.billing_zip),
    billing_email: trimmedOrNull(draft.billing_email),
});
